import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { seriesDetailsData } from '../../features/seriesDetails/seriesDetailsSlice';
import { useParams } from 'react-router-dom';
import { pointsTableData } from '../../features/pointsTable/pointsTableSlice';
import styles from './PointsTable.module.css'

const PointsTable = ({series_id}) => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.pointsTable.data);
    const pending = useSelector((state) => state.pointsTable.pending);
    const error = useSelector((state) => state.pointsTable.error);
    const finalData = data.data;

console.log(finalData)

    useEffect(() => {
        
            dispatch(pointsTableData(series_id));
         
       
      }, [dispatch, series_id]);
    
      if (pending) {
        return <div>Loading...</div>;
      }
      if (error) {
        return <div>Error: {error}</div>;
      }
      if(data.msg === "No Data Found."){
        return <div>No PointsTable at this moment..</div>;
      }
  return (
    <div className={styles.pointsTableWrapper}>
        <table >
          <thead>
            <th>TEAM NAME</th>
            <th>P</th>
            <th>W</th>
            <th>L</th>
            <th>NR</th>
            <th>Pts</th>
            <th>NRR</th>
          </thead>
           <tbody>
            {
              finalData?.map((item, index) => (
                <tr key={index}>
                  <td className={styles.nameAndFlag}>
                     <div className={styles.teamIconImage}><img src={item?.flag} alt="" /></div> 
                    <span className={styles.pointsTableTeamName}>{item.teams}</span>
                  </td>
                  <td>{item.P}</td>
                  <td>{item.W}</td>
                  <td>{item.L}</td>
                  <td>{item.NR}</td>
                  <td>{item.Pts}</td>
                  <td>{item.NRR}</td>
                </tr>
              ))}
          </tbody> 
        </table>
      
    </div>
  )
}

export default PointsTable
